<template>
    <div>
        <h1 class="web-title" v-if="$web.isDesktop">
            Compila il modulo che segue in tutte le sue parti:
        </h1>

        <div class="web-page" :class="{'desktop-card':$web.isDesktop}">

            <!-- Top logo -->
            <TopLogo/>

            <form>

                <!-- Name -->
                <ProfileName
                        :value="profileData.name"
                        :text-ok="contents.ok"
                        @input="updateProfile($event, 'name')"/>

                <!-- Size -->
                <TextInput
                        type="number"
                        :label="contents.size"
                        :append="contents.size_unit"
                        :value="profileData.size"
                        @input="updateProfile($event, 'size')"/>

                <!-- Consumption -->
                <TextInput
                        type="number"
                        :label="contents.consumption"
                        :append="consumptionUnit"
                        :value="profileData.consumption"
                        :show-info="true"
                        @info-click="showConsumptionInfoModal"
                        @input="updateProfile($event, 'consumption')">
                    <ButtonGroup
                            slot="between"
                            :values="periods"
                            :value="profileData.consumption_type"
                            @change="setConsumptionType"/>
                </TextInput>

                <!-- Cost -->
                <TextInput
                        type="number"
                        :label="contents.cost"
                        :append="contents.cost_unit"
                        :value="profileData.cost"
                        :show-info="true"
                        @info-click="showCostInfoModal"
                        @input="updateProfile($event, 'cost')">
                    <ButtonGroup
                            slot="between"
                            :values="periods"
                            :value="profileData.cost_type"
                            @change="setCostType"/>
                </TextInput>

            </form>

            <!-- Continue button -->
            <Btn :text="contents.continue" @click="loadScore" class="mt-5"/>

            <!-- Child view for modals -->
            <router-view/>
        </div>
    </div>
</template>

<script>
    import {profileMixin} from "@/data/profile";
    import contents from "../contents/profile"
    import TextInput from "../components/TextInput"
    import ButtonGroup from "../components/ButtonGroup";
    import TopLogo from "../components/TopLogo";
    import ProfileName from "../components/ProfileName";
    import Btn from "../components/Btn";

    export default {
        name: 'profile-data',
        components: {Btn, ProfileName, ButtonGroup, TextInput, TopLogo},
        mixins: [profileMixin],
        mounted(){
            this.$registerEvent('Pagina', '4. Dati profilo');
        },
        data() {
            return {
                editProfileName: false,
                contents
            };
        },
        methods: {
            toggleEditProfileName() {
                this.editProfileName = !this.editProfileName;
                if (this.editProfileName) {
                    this.$nextTick(() => {
                        let el = this.$refs.profileName;
                        el.focus()
                    });
                }
            },
            updateProfile(target, field) {
                let data = {};
                data[field] = target.value;
                this.$store.commit('updateProfile', data)
            },
            setConsumptionType(consumption_type) {
                this.$store.commit('updateProfile', {consumption_type})
            },
            setCostType(cost_type) {
                this.$store.commit('updateProfile', {cost_type})
            },
            loadScore() {
                if (!this.validateProfile()) {
                    return;
                }
                this.$router.push('/score');
            },
            validateProfile() {
                let profile = this.profileData;

                for (let prop in profile) {
                    if (Object.prototype.hasOwnProperty.call(profile, prop)) {
                        if (!profile[prop]) {
                            this.$alert(this.contents.validation_error);
                            return false;
                        }
                    }
                }

                return true;
            },
            showConsumptionInfoModal() {
                this.$router.push('/profile/consumption-info')
            },
            showCostInfoModal() {
                this.$router.push('/profile/cost-info')
            }
        },
        computed: {
            profileData() {
                return this.$store.state.profile;
            },
            consumptionUnit() {
                return this.contents.consumption_units[
                    this.$store.state.profile.vector
                ];
            }
        }
    };
</script>

<style lang="scss" scoped>
    .web-page.desktop-card {
        .toplogo-container {
            display: none;
        }

        .profile-name {
            margin: 0 0 30px 0 !important;
            background: #016B31;
        }
    }

    .web-title {
        font-family: Poppins, serif;
        font-style: normal;
        font-weight: bold;
        font-size: 30px;
        line-height: 54px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 30px;
    }
</style>